var render, staticRenderFns
import script from "./BarReportClick.vue?vue&type=script&lang=js&"
export * from "./BarReportClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde46c9",
  null
  
)

export default component.exports